export default __webpack_public_path__ + "static/media/Emojis17.bf548144.png";